import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-transfer-sanction-form',
  templateUrl: './transfer-sanction-form.component.html',
  styleUrls: ['./transfer-sanction-form.component.css']
})
export class TransferSanctionFormComponent implements OnInit {

  title="Add Transfer Sanction";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/transfer/transfer-sanction/transfer-sanction-form/transfer-sanction-form.component.ts